import { routes } from '@teetsh/app/src/containers/routes';

export const getSeanceAttachmentUrl = (s3Path, s3Filename, label) =>
  `${
    import.meta.env.VITE_DOWNLOAD_URL
  }/download/${s3Path}/${s3Filename}?filename=${label
    .replaceAll(',', '_')
    .replaceAll(';', '_')
    .replaceAll(':', '_')}`;

type ImagekitOption = 'w' | 'fo' | 'z';
function setTrParam(
  params: URLSearchParams,
  option: ImagekitOption,
  value: string | number,
): string {
  // we need to parse imagekit param tr=w-340%2Cfo-face%2Cz-0.7
  const parsedParam = (params.get('tr')?.split(',') || []).filter(e => e);
  const cleanParam = parsedParam.filter(p => !p.startsWith(`${option}-`));
  params.set('tr', [...cleanParam, `${option}-${value}`].join(','));

  return params.toString();
}

export function buildImageUrl(
  url: string,
  variant: 'imagekit',
  options: {
    width?: number;
    focus?: 'face' | 'auto' | 'top' | 'top_left';
    zoom?: '0.5' | '0.7';
  },
) {
  try {
    const thumbnailImageUrl = new URL(url);
    if (variant === 'imagekit') {
      if (options.width) {
        setTrParam(thumbnailImageUrl.searchParams, 'w', options.width);
      }
      if (options.focus) {
        setTrParam(thumbnailImageUrl.searchParams, 'fo', options.focus);
      }
      if (options.zoom) {
        setTrParam(thumbnailImageUrl.searchParams, 'z', options.zoom);
      }
    }
    return thumbnailImageUrl.toString();
  } catch (e) {
    return url;
  }
}

export const getClassroomConfigurationLink = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) =>
  `${routes.schoolyearsSettings}/${schoolyearId}/ecoles/${schoolId}/general`;
